class HomeBlog extends Component {
    constructor(el) {
        super(el);
        this.minWidth = 768;
        this.heightGetEl = document.querySelector('.BlogItem:first-of-type .BlogItem-picture');
        this.heightSetEl = this.$find('[data-blog-height-set]');
        this.resizeTimeout = null;

        if (this.heightGetEl && this.heightSetEl) {
            this.init();
        }
    }

    init() {
        window.addEventListener('load', () => this.syncHeights());
        window.addEventListener('resize', () => this.handleResize());
        this.syncHeights();
    }

    syncHeights() {
        if (window.innerWidth > this.minWidth) {
            const height = this.heightGetEl.offsetHeight;
            this.heightSetEl.style.height = `${height}px`;
        } else {
            this.heightSetEl.style.height = 'auto';
        }
    }

    handleResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => this.syncHeights(), 150);
    }
}
